import { useQueryStates, parseAsString, parseAsInteger, parseAsBoolean } from 'nuqs';
import { useMemo, useCallback } from 'react';
import { useIngestionState, type IngestionStateAdapter, type IngestionStateParams } from './useIngestionState';

const filterParsers = {
  projectId: parseAsString,
  videoProcessorConfigId: parseAsString,
  assetId: parseAsString,
  stage: parseAsString,
  outcome: parseAsString,
  type: parseAsString,
  correlationId: parseAsString,
  dateStart: parseAsString,
  dateEnd: parseAsString,
  tab: parseAsString.withDefault('pipeline'),
  pipelineView: parseAsString.withDefault('journeys'),
  explorerPage: parseAsInteger.withDefault(1),
  explorerPageSize: parseAsInteger.withDefault(50),
  logWindowStart: parseAsString,
  logWindowEnd: parseAsString,
  liveTail: parseAsBoolean.withDefault(false),
  cameraName: parseAsString,
};

export function useIngestionFilters() {
  const [urlParams, setUrlParams] = useQueryStates(filterParsers, { history: 'replace' });

  const get = useCallback(
    (): IngestionStateParams => ({
      projectId: urlParams.projectId,
      videoProcessorConfigId: urlParams.videoProcessorConfigId,
      assetId: urlParams.assetId,
      stage: urlParams.stage,
      outcome: urlParams.outcome,
      type: urlParams.type,
      correlationId: urlParams.correlationId,
      dateStart: urlParams.dateStart,
      dateEnd: urlParams.dateEnd,
      tab: urlParams.tab,
      pipelineView: urlParams.pipelineView,
      explorerPage: urlParams.explorerPage,
      explorerPageSize: urlParams.explorerPageSize,
      logWindowStart: urlParams.logWindowStart,
      logWindowEnd: urlParams.logWindowEnd,
      liveTail: urlParams.liveTail,
      cameraName: urlParams.cameraName,
    }),
    [urlParams]
  );

  const set = useCallback(
    (updates: Partial<IngestionStateParams>) => {
      setUrlParams(updates);
    },
    [setUrlParams]
  );

  const adapter: IngestionStateAdapter = useMemo(() => ({ get, set }), [get, set]);

  return useIngestionState(adapter);
}
